import React from "react";

import PeakDaysContent from "../components/peak-days/peak-days-content";

const PeakDays = () => {
  return <PeakDaysContent />;
};

export default PeakDays;
